export interface UserInvitePermissions {
    hasDashboard?: boolean;
    hasOrders?: boolean;
    hasFinancialReports?: boolean;
    hasMenuEditing?: boolean;
    hasTopCustomers?: boolean;
    hasAnalytics?: boolean;
    hasPromos?: boolean;
    hasGuestbook?: boolean;
    hasBilling?: boolean;
    hasBillingWrite?: boolean;
    hasEmployees?: boolean;
    hasPayroll?: boolean;
    hasSettings?: boolean;
    hasSettingsWrite?: boolean;
    hasCustomerFeeSettings?: boolean;
    hasEditAdmin?: boolean;
    hasPayouts?: boolean;
    hasSalesReports?: boolean;
    hasReportsMenu?: boolean;
    hasReportsCustomers?: boolean;
    hasReportsLocations?: boolean;
    hasReportsPromotions?: boolean;
    hasReportsLabor?: boolean;
    hasReportsGiftCards?: boolean;
    hasCatering?: boolean;
    hasDevices?: boolean;
}

export enum InviteStatus {
    "ACTIVE" = "Active",
    "ACCEPTED" = "Accepted",
    "DECLINED" = "Declined",
}

export interface UserInvite {
    inviteNonce: string;
    status: InviteStatus;
    storeId: string;
    email: string;
    jobTitle: string;
    wage?: number;
    pin?: number;
    permissions: UserInvitePermissions;
    createdAt: string;
    storeName?: string;
    storeLogoUrl?: string;
    existingUser?: boolean;
    identifier: string;
    existingUserIsAdmin?: boolean;
    _id: string;
}
